import React from 'react';
import { Link } from 'react-router-dom';
import { defineMessages, useIntl } from 'react-intl';
import AppNav from '../AppNav/AppNav';
import { sharedMessages } from '../../utils/uiMessages';

const messages = defineMessages({
  antecedentBasisChecker: {
    id: 'Antecedent Basis Checker',
    defaultMessage: 'Antecedent Basis Checker',
  },
  availableNow: {
    id: 'Available now',
    defaultMessage: 'Available now',
  },
  backendAssistedTools: {
    id: 'Backend-assisted tools',
    defaultMessage: 'Backend-assisted tools',
  },
  browserOnlyTools: {
    id: 'Browser-only tools',
    defaultMessage: 'Browser-only tools',
  },
  claimDependencyChecker: {
    id: 'Claim Dependency Checker',
    defaultMessage: 'Claim Dependency Checker',
  },
  dependencyCheckerNote: {
    id: 'Detect multi-multi dependencies for Japanese or English claim sets.',
    defaultMessage:
      'Detect multi-multi dependencies for Japanese or English claim sets.',
  },
  localTools: {
    id: 'Local tools',
    defaultMessage: 'Local tools',
  },
  oaProfiles: {
    id: 'OA Profiles',
    defaultMessage: 'OA Profiles',
  },
  oaProfilesNote: {
    id: 'Manage reusable translation instructions, example pairs, and DOCX templates for OA output.',
    defaultMessage:
      'Manage reusable translation instructions, example pairs, and DOCX templates for OA output.',
  },
  openAntecedentBasis: {
    id: 'Open antecedent basis',
    defaultMessage: 'Open antecedent basis',
  },
  openDependencyCheck: {
    id: 'Open dependency check',
    defaultMessage: 'Open dependency check',
  },
  openOaProfiles: {
    id: 'Open OA profiles',
    defaultMessage: 'Open OA profiles',
  },
  practiceTools: {
    id: 'Practice tools',
    defaultMessage: 'Practice tools',
  },
  serverTools: {
    id: 'Server tools',
    defaultMessage: 'Server tools',
  },
  toolsNote: {
    id: 'Keep analysis tools separate from workload records, but linked back to matters.',
    defaultMessage:
      'Keep analysis tools separate from workload records, but linked back to matters.',
  },
  browserToolsNote: {
    id: 'Input stays in the browser. Use these for deterministic checks that do not need the backend.',
    defaultMessage:
      'Input stays in the browser. Use these for deterministic checks that do not need the backend.',
  },
  serverToolsNote: {
    id: 'Input is sent to backend services for analysis or translation.',
    defaultMessage:
      'Input is sent to backend services for analysis or translation.',
  },
  antecedentCheckerNote: {
    id: 'Detect missing basis for 前記 and 該 references along the dependency chain.',
    defaultMessage:
      'Detect missing basis for 前記 and 該 references along the dependency chain.',
  },
});

export default function ToolsPage() {
  const intl = useIntl();

  return (
    <main className="patent-section">
      <section className="patent-section__shell">
        <AppNav currentPath="/tools" />
        <header className="patent-section__hero">
          <p className="patent-section__eyebrow">
            {intl.formatMessage(sharedMessages.tools)}
          </p>
          <h1>{intl.formatMessage(messages.practiceTools)}</h1>
          <p className="patent-section__note">
            {intl.formatMessage(messages.toolsNote)}
          </p>
          <div className="patent-section__actions">
            <Link className="patent-section__ghost" to="/">
              {intl.formatMessage(sharedMessages.backToOverview)}
            </Link>
          </div>
        </header>

        <section className="patent-section__group">
          <div className="patent-section__group-head">
            <div>
              <p className="patent-section__chip patent-section__chip--muted">
                {intl.formatMessage(messages.localTools)}
              </p>
              <h2>{intl.formatMessage(messages.browserOnlyTools)}</h2>
              <p className="patent-section__note">
                {intl.formatMessage(messages.browserToolsNote)}
              </p>
            </div>
          </div>
          <div className="patent-section__list patent-section__list--tools">
            <article className="patent-section__card patent-section__card--tool">
              <p className="patent-section__chip">
                {intl.formatMessage(messages.availableNow)}
              </p>
              <h2>{intl.formatMessage(messages.claimDependencyChecker)}</h2>
              <p className="patent-section__note">
                {intl.formatMessage(messages.dependencyCheckerNote)}
              </p>
              <Link className="patent-section__action" to="/tool-dependency">
                {intl.formatMessage(messages.openDependencyCheck)}
              </Link>
            </article>
          </div>
        </section>

        <section className="patent-section__group">
          <div className="patent-section__group-head">
            <div>
              <p className="patent-section__chip patent-section__chip--muted">
                {intl.formatMessage(messages.serverTools)}
              </p>
              <h2>{intl.formatMessage(messages.backendAssistedTools)}</h2>
              <p className="patent-section__note">
                {intl.formatMessage(messages.serverToolsNote)}
              </p>
            </div>
          </div>
          <div className="patent-section__list patent-section__list--tools">
            <article className="patent-section__card patent-section__card--tool">
              <p className="patent-section__chip">
                {intl.formatMessage(messages.availableNow)}
              </p>
              <h2>{intl.formatMessage(messages.oaProfiles)}</h2>
              <p className="patent-section__note">
                {intl.formatMessage(messages.oaProfilesNote)}
              </p>
              <Link className="patent-section__action" to="/oa-profiles">
                {intl.formatMessage(messages.openOaProfiles)}
              </Link>
            </article>
            <article className="patent-section__card patent-section__card--tool">
              <p className="patent-section__chip">
                {intl.formatMessage(messages.availableNow)}
              </p>
              <h2>{intl.formatMessage(messages.antecedentBasisChecker)}</h2>
              <p className="patent-section__note">
                {intl.formatMessage(messages.antecedentCheckerNote)}
              </p>
              <Link className="patent-section__action" to="/tool-antecedent">
                {intl.formatMessage(messages.openAntecedentBasis)}
              </Link>
            </article>
          </div>
        </section>
      </section>
    </main>
  );
}
